import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import {
    SubscriptionModelInterface,
    SubscriptionModelResponse,
} from 'src/app/interface/subscription-model.interface';
import { OpenIdProfilePaginatorBase } from 'src/app/mixin/presets';

import { OpenIdService } from 'src/app/service/open-id.service';

@Component({
    selector: 'app-subscriptions',
    templateUrl: './subscriptions.component.html',
    styleUrls: ['./subscriptions.component.css'],
})
export class SubscriptionsComponent
    extends OpenIdProfilePaginatorBase
    implements AfterViewInit, OnInit
{
    public columnHeadings: string[] = [
        'id',
        'sender_email',
        'plan',
        'started_at',
        'expires_at',
        'cancelled_at',
    ];

    private offset: number = 0;
    public subscriptionModels: SubscriptionModelInterface[] = [];

    @ViewChild(MatPaginator) public paginator?: MatPaginator;
    constructor(private httpClient: HttpClient, openIdService: OpenIdService) {
        super(openIdService);
    }

    ngOnInit(): void {
        this.$openIdReady.subscribe(() => this.getRecords());
        this.openIdService.$userProfile.subscribe((userProfile) => {
            //console.log(userProfile.canCreateSubscription);
        });
    }

    ngAfterViewInit(): void {
        this.handlePaging(this.paginator!, (offset) => this.getRecords(offset));
    }

    public getRecords(offset: number = 0) {
        this.offset = offset;
        let options = {
            params: new HttpParams()
                .set('limit', this.pagingPageSize)
                .set('offset', offset)
                .set('ordering', '-started_at')
                .set('view', 'owned'),
        };

        this.httpClient
            .get<SubscriptionModelResponse>('subscriptions/', options)
            .subscribe((response: SubscriptionModelResponse) => {
                this.pagingItemCount = response.count;
                this.subscriptionModels = response.results;
            });
    }
}
